export default __webpack_public_path__ + "static/media/wake_up.a24171ff.mp3";